/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../../components/clearCach/clear";
import {
  X,
  Zap,
  Check,
  RefreshCw,
  Lock,
  Info,
  Key,
  BarChart,
  ExternalLink,
  Navigation,
} from "lucide-react";
import { useTranslation } from "react-i18next";
export default function ActivationTiktokConversion({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);
  const MySwal = withReactContent(Swal);
  const products = useSelector((state) => state.ProductsReducer);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!data.TikTokAccessToken) {
      await showAlert("warning", t("servicePageActivation.TiktokApiConversion.alerts.missingData.title"), t("servicePageActivation.TiktokApiConversion.alerts.missingData.description"));
      return;
    }

    try {
      setLoading(true);
      apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);

      await showAlert("success", t("servicePageActivation.TiktokApiConversion.alerts.successActivation.title"), t("servicePageActivation.TiktokApiConversion.alerts.successActivation.description"));
      close();
    } catch (error) {
      setLoading(false);

      await showAlert("error", t("servicePageActivation.TiktokApiConversion.alerts.errorSaving.title"), t("servicePageActivation.TiktokApiConversion.alerts.errorSaving.description"));

      console.error("Error saving TikTok API settings:", error);
    }
  };

  const handleDisable = async (e) => {
    e.preventDefault();

    // Vérifier si la plateforme est déjà désactivée
    if (!data.TikTokAccessToken) {
      await Swal.fire({
        icon: "info",
        title: t("servicePageActivation.TiktokApiConversion.alerts.notActivated.title"),
        text: t("servicePageActivation.TiktokApiConversion.alerts.notActivated.description")
      });
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour les données (désactivation)
      const updatedData = {
        ...data,
        // TikTokPixelCode: "",
        TikTokAccessToken: ""
      };

      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t("servicePageActivation.TiktokApiConversion.alerts.successDeactivation.title"),
        text: t("servicePageActivation.TiktokApiConversion.alerts.successDeactivation.description")
      });

      // Mettre à jour l'état local si nécessaire
      setData(updatedData);
    } catch (error) {
      setLoading(false);
      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.TiktokApiConversion.alerts.errorDisabling.title"),
        text: t("servicePageActivation.TiktokApiConversion.alerts.errorDisabling.description")
      });

      console.error("Error disabling Order Dz:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.title"),
      t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.description"),
      true,
      t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.confirmButton")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // TikTok conversion benefits
  const tiktokBenefits = [
    {
      title: t("servicePageActivation.TiktokApiConversion.benefits.0.title"),
      description: t("servicePageActivation.TiktokApiConversion.benefits.0.description"),
      icon: <Navigation className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.TiktokApiConversion.benefits.1.title"),
      description: t("servicePageActivation.TiktokApiConversion.benefits.1.description"),
      icon: <BarChart className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.TiktokApiConversion.benefits.2.title"),
      description: t("servicePageActivation.TiktokApiConversion.benefits.2.description"),
      icon: <Zap className="text-green-500" size={20} />,
    },
  ];

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#1e293b] dark:!border-gray-700">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#3b2f14]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3 dark:!text-[#b47ed6]">
              {t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.title")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto dark:!text-gray-400">
              {t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.description")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.TiktokApiConversion.alerts.paidFeature.confirmButton")}
            </button>
          </div>
        </div>
      </div>

    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center dark:!text-[#b47ed6]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-2 text-[#9e68ba] dark:!text-[#b47ed6]"
            >
              <path d="M9 12a9 9 0 0 0 9 9" />
              <path d="M9 3v18" />
              <path d="M9 12a9 9 0 0 1 9-9" />
            </svg>
            {t("servicePageActivation.TiktokApiConversion.title")}
          </h3>
          <p className="text-gray-600 mb-4 dark:!text-gray-400">
            {t("servicePageActivation.TiktokApiConversion.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg border border-blue-200 p-4 flex mb-6 dark:!bg-[#1e3a5f] dark:!border-blue-700">
            <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
            <div>
              <p className="font-medium text-blue-800 mb-1 dark:!text-blue-300">
                {t("servicePageActivation.TiktokApiConversion.about.title")}
              </p>
              <p className="text-blue-700 text-sm dark:!text-blue-400">
                {t("servicePageActivation.TiktokApiConversion.about.text")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Pixel ID Input */}
          {/* <div className="space-y-2">
            <label className="block text-sm font-medium text-[#9e68ba] dark:!text-[#b47ed6]">
              {t("servicePageActivation.TiktokApiConversion.inputs.pixelId.label")}
            </label>
            <div className="relative">
              <input
                type="text"
                className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors dark:!bg-[#1f1f1f] dark:!border-gray-700 dark:!text-white"
                placeholder={t("servicePageActivation.TiktokApiConversion.inputs.pixelId.placeholder")}
                value={data.TikTokPixelCode || ""}
                onChange={(e) =>
                  setData({ ...data, TikTokPixelCode: e.target.value })
                }
              />
            </div>
            <p className="text-xs text-gray-500 flex items-center dark:!text-gray-400">
              <Info size={12} className="ml-1" />
              {t("servicePageActivation.TiktokApiConversion.inputs.pixelId.helper")}
            </p>
          </div> */}

          {/* Access Token Input */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-[#9e68ba] dark:!text-[#b47ed6]">
              {t("servicePageActivation.TiktokApiConversion.inputs.accessToken.label")}
            </label>
            <div className="relative">
              <input
                type="text"
                className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors dark:!bg-[#1f1f1f] dark:!border-gray-700 dark:!text-white"
                placeholder={t("servicePageActivation.TiktokApiConversion.inputs.accessToken.placeholder")}
                value={data.TikTokAccessToken || ""}
                onChange={(e) =>
                  setData({ ...data, TikTokAccessToken: e.target.value })
                }
              />
            </div>
            <p className="text-xs text-gray-500 dark:!text-gray-400">
              {t("servicePageActivation.TiktokApiConversion.inputs.accessToken.helper")}
            </p>
          </div>

          {/* Benefits Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
            {tiktokBenefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm dark:!bg-[#2a2a2a] dark:!border-gray-700"
              >
                <div className="flex items-center mb-2">
                  {benefit.icon}
                  <h5 className="font-medium text-gray-800 mr-2 text-sm dark:!text-gray-200">
                    {benefit.title}
                  </h5>
                </div>
                <p className="text-xs text-gray-600 dark:!text-gray-400">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* Documentation Link */}
          <div className="mt-2">
            <a
              href="https://ads.tiktok.com/marketing_api/docs?id=1701890979375106"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9e68ba] hover:text-[#9e68ba] text-sm font-medium flex items-center dark:!text-[#b47ed6]"
            >
              <ExternalLink size={14} className="ml-1" />
              {t("servicePageActivation.TiktokApiConversion.documentation.linkText")}
            </a>
          </div>

          {/* Tips Section */}
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100 dark:!bg-[#3a300f] dark:!border-yellow-700">
            <h4 className="font-medium text-yellow-800 mb-2 flex items-center dark:!text-yellow-400">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.TiktokApiConversion.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
              <li>{t("servicePageActivation.TiktokApiConversion.tips.0")}</li>
              <li>{t("servicePageActivation.TiktokApiConversion.tips.1")}</li>
              <li>{t("servicePageActivation.TiktokApiConversion.tips.2")}</li>
              <li>{t("servicePageActivation.TiktokApiConversion.tips.3")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.TiktokApiConversion.buttons.submitting")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("servicePageActivation.TiktokApiConversion.buttons.submit")}
                </>
              )}
            </button>
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDisable}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("servicePageActivation.TiktokApiConversion.buttons.cancel")}
            </Button>
          </div>
        </form>

      </div>
    </div>
  );
}
